import styled from '@emotion/styled';

export const EventDetailsHeaderWrapper = styled('header', { label: 'EventDetailsHeaderWrapper' })`
    align-items: center;
    display: flex;
    position: relative;
`;

export const EventDetailsHeader = styled('h3', { label: 'EventDetailsHeader' })`
    font-size: 1.375rem;
    font-weight: 300;
    width: 100%;
    padding-right: 284px;
`;

export const EventDetailsInfo = styled('span', { label: 'EventDetailsInfo' })`
    color: rgba(0, 0, 0, 0.7);
    font-size: 0.8125rem;
    margin-left: 10px;
`;

export const TabNav = styled('nav', { label: 'TabNav' })`
    background: #ccc;
    display: flex;
    justify-content: center;
`;

interface TabNavItemPropsType {
    isActive: boolean;
}

export const TabNavItem = styled('button', { label: 'TabNavItem' })<TabNavItemPropsType>`
    background: ${({ isActive }): string => isActive ? '#ddd' : 'transparent'};
    border-radius: 0;
    border: none;
    color: #2b2b2b;
    cursor: pointer;
    font-size: 1rem;
    line-height: 1.4;
    padding: 10px;
    text-align: center;
    transition: background-color .2s ease;
`;

export const TabsContainerWrapper = styled('div', { label: 'TabsContainerWrapper' })`
    margin: 0 -8px -8px;
    background: #ddd;
`;

export const TabsContentWrapper = styled('div', { label: 'TabsContentWrapper' })`
    padding: 10px;
`;

